document.addEventListener("DOMContentLoaded", function () {
  const rangeInput = document.querySelector(".calculator__range");
  const currentValue = document.querySelector(".calculator__current-value");
  const zusValue = document.querySelector(".calculator__zus-value");
  const totalCost = document.querySelector(".calculator__total-cost-value");
  const marzaValue = document.querySelector(".calculator__marza-value");
  const fvValue = document.querySelector(".calculator__fv-value");

  currentValue.textContent = rangeInput.value + " zł";

  const updateCalculatorValues = function (value) {
    console.log(value);
    value = Number(value);
    const zus = ((value) * 0.205);
    const total = ((value) + zus);
    const marza = ((value) * 0.108);
    const fv = total + marza + 1.46 + 0.16 + 0.17 + 0.5;

    currentValue.textContent = Math.round(value * 100) / 100 + " zł";
    zusValue.textContent = Math.round(zus * 100) / 100 + " zł";
    totalCost.textContent = Math.round(total * 100) / 100 + " zł";
    marzaValue.textContent = Math.round(marza * 100) / 100 + " zł";
    fvValue.textContent = Math.round(fv * 100) / 100 + " zł";
  };

  rangeInput.addEventListener("input", function () {
    updateCalculatorValues(this.value);
  });
  updateCalculatorValues(rangeInput.value);
});
